import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function RefreshIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.86477 2.85989C5.68959 3.82834 3.93134 5.54115 2.90628 7.69023C1.88122 9.83932 1.65662 12.2836 2.27288 14.5835C2.88914 16.8834 4.30581 18.888 6.26808 20.2366C8.23035 21.5852 10.6094 22.1894 12.9774 21.9406C15.3454 21.6917 17.5469 20.606 19.1859 18.8789C20.8249 17.1518 21.7938 14.8965 21.9184 12.5187C21.9473 11.9672 21.5237 11.4966 20.9721 11.4677C20.4206 11.4388 19.9501 11.8625 19.9212 12.414C19.8215 14.3162 19.0463 16.1205 17.7351 17.5022C16.4239 18.8839 14.6628 19.7524 12.7684 19.9515C10.874 20.1506 8.9707 19.6673 7.40089 18.5884C5.83107 17.5094 4.69774 15.9058 4.20473 14.0659C3.71173 12.226 3.89141 10.2705 4.71146 8.55126C5.5315 6.83199 6.9381 5.46174 8.67825 4.68698C10.4184 3.91222 12.3779 3.78379 14.2043 4.32479C14.7152 4.47612 15.2094 4.67552 15.6853 4.9153L14.724 6.09605C14.0604 6.91121 14.6912 8.12515 15.7397 8.05065L19.7767 7.76381C20.0445 7.74478 20.2935 7.6188 20.4675 7.41425C20.6415 7.20969 20.7259 6.94374 20.7017 6.67629L20.3354 2.62386C20.2404 1.57325 18.9334 1.1476 18.238 1.94077L17.0023 3.34999C16.3048 2.96284 15.5603 2.64057 14.7723 2.40715C12.4893 1.7309 10.04 1.89144 7.86477 2.85989Z"
				fill="currentColor"
			/>
		</svg>
	);
}

RefreshIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default RefreshIcon;
